<template>
  <div class="flex-column">
    <sticky :className="'sub-navbar'">
      <div class="filter-container">
        <el-input @keyup.enter.native="handleFilter" size="mini" style="width: 200px;" :placeholder="'名称'"
                  v-model="listQuery.key">
          <el-button slot="append" icon="el-icon-caret-bottom" @click="dialogQueryVisible = true"></el-button>
          <i slot="suffix" class="el-input__icon el-icon-search" @click="handleFilter"></i>
        </el-input>
        <el-button type="primary" icon="el-icon-refresh" size="mini" class="filter-item" @click="handleClear">重置
        </el-button>
        <permission-btn moduleName='sysBillNoRules' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
      </div>
    </sticky>
    <div class="app-container flex-item">
      <div class="bg-white fh">
        <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
                  style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"
                  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
          <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
          <el-table-column type="selection" align="center" width="55"></el-table-column>
          <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width"
                           :label="item.description"
                           :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false"
                           :show-overflow-tooltip="item.tooltip">
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]"
                           v-if="item.isSel">
              </select-type>
              <span v-else>
                <span
                  v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{ scope.row[item.key] | dateFormat }}</span>
                <span v-else>{{ scope.row[item.key] }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
                    :limit.sync="listQuery.limit" @pagination="handleCurrentChange"/>
      </div>

      <el-dialog v-el-drag-dialog class="dialog-mini" width="55%" :title="textMap[dialogStatus]"
                 :visible.sync="dialogFormVisible" :close-on-click-modal="false">

        <el-form :rules="rules" ref="dataForm" :model="temp" label-position="right" label-width="100px">

          <el-form-item size="small" :label="'单据类型'" prop="billType">
            <el-input v-model="temp.billType" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item size="small" :label="'单据名称'" prop="billName">
            <el-input v-model="temp.billName" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item size="small" :label="'单据前缀'" prop="prexNo">
            <el-input v-model="temp.prexNo" maxlength="50"></el-input>
          </el-form-item>
          <el-form-item size="small" :label="'编号递增规则'" prop="noAddRule">
            <select-type size="small" :isEdit="true" typeId="SysBillNo_NoAddRule"
                         v-model="temp.noAddRule"></select-type>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button size="mini" @click="dialogFormVisible = false">取消</el-button>
          <el-button size="mini" v-if="dialogStatus=='create'" type="primary" @click="createData">确认</el-button>
          <el-button size="mini" v-else type="primary" @click="updateData">确认</el-button>
        </div>
      </el-dialog>
      <el-dialog class="dialog-mini" v-el-drag-dialog :title="'快速查询'" width="500px"
                 :visible.sync="dialogQueryVisible">
        <div style="height:300px;overflow:auto;">
          <el-form ref="queryForm" label-position="right" label-width="60px">

          </el-form>
        </div>
        <div slot="footer">
          <el-button size="mini" type="primary" @click="handleFilter">查询</el-button>
          <el-button size="mini" @click="handleClear">清空</el-button>
        </div>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import * as sysBillNoRules from '@/api/sysbillnorules';
import waves from '@/directive/waves'; // 水波纹指令
import Sticky from '@/components/Sticky';
import permissionBtn from '@/components/PermissionBtn';
import Pagination from '@/components/Pagination';
import elDragDialog from '@/directive/el-dragDialog';
import SelectType from '@/components/SelectType';
import { parseTime } from '@/utils/index';

export default {
  name: 'sysBillNoRules',
  components: { Sticky, permissionBtn, Pagination, SelectType },
  directives: {
    waves,
    elDragDialog
  },
  data() {
    return {
      multipleSelection: [], // 列表checkbox选中的值
      tableKey: 0,
      list: null,
      total: 0,
      listLoading: true,
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        sort: '',
        order: '',
        key: undefined,
        appId: undefined
      },
      statusOptions: [
        { key: 1, display_name: '按月递增' },
        { key: 2, display_name: '按天递增' }
      ],
      temp: {
        id: '', // Id
        billType: '', // 单据类型
        billName: '', // 单据名称
        prexNo: '', // 单据前缀
        noAddRule: '', // 编号递增规则
        currNo: '', // 最新编号
        extendInfo: '' // 其他信息,防止最后加逗号，可以删除
      },
      dialogFormVisible: false,
      dialogStatus: '',
      headerList: [],
      textMap: {
        update: '编辑',
        create: '添加'
      },
      dialogQueryVisible: false,
      dialogPvVisible: false,
      pvData: [],
      rules: {
        appId: [{ required: true, message: '必须选择一个应用', trigger: 'change' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        billType: [{ required: true, message: '不能为空', trigger: 'change' }],
        prexNo: [{ required: true, message: '不能为空', trigger: 'change' }]
      },
      downloadLoading: false
    };
  },
  filters: {
    filterInt(val) {
      switch (val) {
        case null:
          return '';
        case 1:
          return '状态1';
        case 2:
          return '状态2';
        default:
          return '默认状态';
      }
    },
    statusFilter(disable) {
      const statusMap = {
        false: 'color-success',
        true: 'color-danger'
      };
      return statusMap[disable];
    },
    dateFormat(datetitme) { // 时间格式化
      return datetitme ? parseTime(new Date(datetitme), '{y}-{m}-{d}') : '';
    }
  },
  created() {
    this.getList();
  },
  methods: {
    rowClick(row) {
      this.$refs.mainTable.clearSelection();
      this.$refs.mainTable.toggleRowSelection(row);
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    onBtnClicked: function(domId) {
      // console.log('you click:' + domId)
      switch (domId) {
        case 'btnAdd':
          this.handleCreate();
          break;
        case 'btnEdit':
          if (this.multipleSelection.length !== 1) {
            this.$message({
              message: '只能选中一个进行编辑',
              type: 'error'
            });
            return;
          }
          this.handleUpdate(this.multipleSelection[0]);
          break;
        case 'btnDel':
          if (this.multipleSelection.length < 1) {
            this.$message({
              message: '至少删除一个',
              type: 'error'
            });
            return;
          }
          this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleDelete(this.multipleSelection);
          }).catch(() => {
          });
          break;
        default:
          break;
      }
    },
    getList() {
      this.listLoading = true;
      sysBillNoRules.getList(this.listQuery).then(response => {
        this.list = response.data;
        response.columnHeaders.forEach((item) => {
          item.key = item.key.substring(0, 1).toLowerCase() + item.key.substring(1);
        });
        this.headerList = response.columnHeaders.filter(u => u.browsable);
        this.total = response.count;
        this.listLoading = false;
      });
    },
    resetListQuery() {
      this.listQuery = { // 查询条件
        page: 1,
        limit: 20,
        sort: '',
        order: '',
        key: '',
        appId: ''
      };
    },
    handleClear() { // 清空查询
      this.resetListQuery();
      this.getList();
    },
    handleFilter() {
      this.dialogQueryVisible = false;
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val.page;
      this.listQuery.limit = val.limit;
      this.getList();
    },
    handleModifyStatus(row, disable) { // 模拟修改状态
      this.$message({
        message: '操作成功',
        type: 'success'
      });
      row.disable = disable;
    },
    resetTemp() {
      this.temp = {
        id: '',
        billType: '',
        billName: '',
        prexNo: '',
        noAddRule: '',
        currNo: '',
        createDate: '',
        lastUpdateDate: '',
        extendInfo: ''
      };
    },
    handleCreate() { // 弹出添加框
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    createData() { // 保存提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          sysBillNoRules.add(this.temp).then(() => {
            // this.list.unshift(this.temp)
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '创建成功',
              type: 'success',
              duration: 2000
            });
            this.getList();
          });
        }
      });
    },
    handleUpdate(row) { // 弹出编辑框
      this.temp = Object.assign({}, row); // copy obj
      this.temp.noAddRule = this.temp.noAddRule ? this.temp.noAddRule.toString() : '';
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() { // 更新提交
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          sysBillNoRules.update(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: '成功',
              message: '更新成功',
              type: 'success',
              duration: 2000
            });
          });
        }
      });
    },
    handleDelete(rows) { // 多行删除
      sysBillNoRules.del(rows.map(u => u.id)).then(() => {
        this.$notify({
          title: '成功',
          message: '删除成功',
          type: 'success',
          duration: 2000
        });
        rows.forEach(row => {
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      });
    },
    handleSortChange(column) {
      this.listQuery.sort = column.prop;
      this.listQuery.order = column.order;
      this.handleFilter();
    }
  }
};
</script>
<style>
.dialog-mini .el-select {
  width: 100%;
}
</style>
